module.exports = [{"code":1,"name":"APP"},{"code":2,"name":"小程序"},{"code":3,"name":"平台"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/source.json
// module id = af+y
// module chunks = 11